/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState, useEffect } from 'react';
import ClipLoader from 'react-spinners/ClipLoader';

function CreateOnDemandSyncModal({
  isOpen, onClose, onCreate, isLoading, availableFunctions, error,
}) {
  const [functionName, setFunctionName] = useState('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');

  useEffect(() => {
    if (isOpen) {
      setFunctionName('');
      setStartTime('');
      setEndTime('');
    }
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  const startUtc = startTime ? new Date(startTime).toISOString() : null;
  const endUtc = endTime ? new Date(endTime).toISOString() : null;
  const isValid = functionName && startUtc && endUtc && startUtc < endUtc;

  const handleSubmit = () => {
    if (!isValid) return;
    onCreate({
      function_name: functionName,
      start_time: startUtc,
      end_time: endUtc,
    });
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div
        className="modal-backdrop"
        onClick={() => onClose(true)}
        onKeyDown={(event) => {
          if (event.key === 'Escape') {
            onClose(true);
          }
        }}
        tabIndex={-1}
        aria-hidden="true"
      />

      <div className="modal w-[460px]">
        <div className="modal-header">
          <h2 className="text-lg font-semibold text-surface-900">Create On-Demand Sync</h2>
        </div>
        <div className="modal-body flex flex-col gap-4">
          <div className="flex flex-col gap-1">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label htmlFor="ods-function-name" className="text-xs font-medium text-surface-600">
              Function <span className="text-error-dark">*</span>
            </label>
            <select
              id="ods-function-name"
              value={functionName}
              onChange={(e) => setFunctionName(e.target.value)}
              required
              className="border border-surface-300 rounded-md px-2 py-1.5 text-sm bg-white"
            >
              <option value="" disabled>Select a function...</option>
              {availableFunctions.map((fn) => (
                <option key={fn} value={fn}>{fn}</option>
              ))}
            </select>
            <p className="text-xs text-surface-400">
              Don&apos;t see a function supported?{' '}
              <a href="mailto:support@trackstarhq.com" className="text-accent-600 underline">
                Reach out to us
              </a>{' '}
              to add new functions.
            </p>
          </div>
          <div className="flex flex-col gap-1">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label htmlFor="ods-start-time" className="text-xs font-medium text-surface-600">
              Start time (your local timezone) <span className="text-error-dark">*</span>
            </label>
            <input
              id="ods-start-time"
              type="datetime-local"
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
              required
              className="border border-surface-300 rounded-md px-2 py-1.5 text-sm"
            />
          </div>
          <div className="flex flex-col gap-1">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label htmlFor="ods-end-time" className="text-xs font-medium text-surface-600">
              End time (your local timezone) <span className="text-error-dark">*</span>
            </label>
            <input
              id="ods-end-time"
              type="datetime-local"
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
              required
              className="border border-surface-300 rounded-md px-2 py-1.5 text-sm"
            />
          </div>
          {startUtc && endUtc && startUtc >= endUtc && (
            <p className="text-xs text-error-dark">End time must be after start time.</p>
          )}
          {startUtc && endUtc && startUtc < endUtc && (
            <p className="text-xs text-surface-400">
              Sent as UTC: {startUtc} → {endUtc}
            </p>
          )}
          {error && (
            <p className="text-xs text-error-dark">{error}</p>
          )}
        </div>
        <div className="modal-footer">
          {isLoading ? (
            <ClipLoader size={20} color="#D4532A" />
          ) : (
            <>
              <button
                type="button"
                onClick={() => onClose(true)}
                className="btn btn-secondary"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleSubmit}
                disabled={!isValid}
                className="btn btn-accent disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Create Sync Job
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default CreateOnDemandSyncModal;
